import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "sonner";
import { StoreProvider } from "@/context/StoreContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import ValueBadges from "@/components/ValueBadges";
import Catalog from "@/components/Catalog";
import LocationSection from "@/components/LocationSection";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import CheckoutModal from "@/components/CheckoutModal";
import ProductModal from "@/components/ProductModal";
import FishCursor from "@/components/FishCursor";
import Preloader from "@/components/Preloader";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <StoreProvider>
      <div className="min-h-screen bg-black font-sans text-white antialiased">
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <ValueBadges />
          <Catalog />
          <LocationSection />
        </main>
        <Footer />
        <CartDrawer />
        <ProductModal />
        <CheckoutModal />
        <FishCursor />
        <Preloader />
        <Toaster theme="dark" position="bottom-right" />
      </div>
    </StoreProvider>
  );
}

export default App;
